import { render, staticRenderFns } from "./CourseSoldOutTip.vue?vue&type=template&id=ad9dc2dc&scoped=true"
import script from "./CourseSoldOutTip.vue?vue&type=script&lang=js"
export * from "./CourseSoldOutTip.vue?vue&type=script&lang=js"
import style0 from "./CourseSoldOutTip.vue?vue&type=style&index=0&id=ad9dc2dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad9dc2dc",
  null
  
)

export default component.exports